import React, { useEffect, useState } from 'react'
// import 'react-spring-bottom-sheet/dist/style.css'
import { ToastContainer } from 'react-toastify'
import { useViewPort } from '../ViewportProvider.js'
import CreateTripDialog from '../components/location/map-components/CreateTrip/CreateTripDialog.js'
import { DragAndMoveComponent } from '../components/location/map-components/DragMove/DragAndMoveComponent.jsx'
import MovePositionDialog from '../components/location/map-components/DragMove/MovePositionDialog.js'
import GoogleMapContainer from '../components/location/map-components/GoogleMapContainer.jsx'
import CreateTripButton from '../components/location/map-components/MapButtons.jsx'
import GpsTable from '../components/location/map-components/gps_page_table.js'
import Sidebar from '../components/sidebar/sidebar.jsx'
import '../scss/button.scss'
import '../scss/map.scss'
import { useEmulatorStore } from '../stores/emulator/store.tsx'

const GPS = () => {
  const setMicCheck = useEmulatorStore((state) => state.setMicEnabled)
  const [microphonePermission, setMicrophonePermission] = useState('prompt')
  const [isSpinning, setSpinning] = useState(false)
  const [seed, setSeed] = useState(1)
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const { width } = useViewPort()
  const breakpoint = 768
  const isMobile = width < breakpoint
  // const toggleDrawer = (newOpen) => () => {
  //   setOpen(newOpen)
  // }
  // OLD CODE WHICH WAS ALREADY THERE. NOT WORKING CODE!

  // useEffect(() => {
  //   if (window.location.pathname === '/gps') {
  //     if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
  //       // Attempt to access the user's media devices (microphone)
  //       navigator.mediaDevices
  //         .getUserMedia({ audio: true })
  //         .then((stream) => {
  //           console.log(stream)
  //           // Stop all tracks once we have the permission
  //           stream.getTracks().forEach((track) => track.stop())
  //         })
  //         .catch((error) => {
  //           console.log(error)
  //         })
  //     }

  //     // For granted and denied status
  //     const checkMicrophonePermission = async () => {
  //       try {
  //         // Check microphone permission status
  //         const permissionStatus = await navigator.permissions.query({
  //           name: 'microphone'
  //         })

  //         if (permissionStatus.state === 'granted') {
  //           setMicCheck(true)
  //         }

  //         // Listen for changes in permission status
  //         permissionStatus.onchange = () => {
  //           if (permissionStatus.state === 'granted') {
  //             setMicCheck(true)
  //           }
  //         }
  //       } catch (error) {
  //         console.error('Error checking microphone permission:', error)
  //       }
  //     }

  //     checkMicrophonePermission()
  //     return () => {
  //       // Cleanup if necessary
  //     }
  //   }
  // }, [setMicCheck])

  // OLD CODE WORKING FOR GOOGLE CHROME, FIREFOX AND EDGE: BUT NOT IN SAFARI

  // useEffect(() => {
  //   const checkMicrophonePermission = async () => {
  //     try {
  //       const permissionStatus = await navigator.permissions.query({ name: 'microphone' })
  //       setMicrophonePermission(permissionStatus.state)

  //       permissionStatus.onchange = () => {
  //         setMicrophonePermission(permissionStatus.state)
  //       }
  //     } catch (error) {
  //       console.error('Error checking microphone permission:', error)
  //     }
  //   }

  //   checkMicrophonePermission()
  // }, [])

  // useEffect(() => {
  //   if (microphonePermission === 'granted') {
  //     setMicCheck(true)
  //   } else {
  //     setMicCheck(false)
  //   }
  // }, [microphonePermission, setMicCheck])

  // CODE WHICH MIGHT WORK FOR SAFARI

  useEffect(() => {
    const checkMicrophonePermission = async () => {
      try {
        const permissionStatus = await navigator.permissions.query({
          name: 'microphone'
        })
        setMicrophonePermission(permissionStatus.state)
        permissionStatus.onchange = () => {
          setMicrophonePermission(permissionStatus.state)
        }
      } catch (error) {
        console.error('Error checking microphone permission:', error)
      }
    }
    checkMicrophonePermission()
  }, [])

  useEffect(() => {
    if (microphonePermission === 'granted') {
      setMicCheck(true)
    } else {
      setMicCheck(false)
    }
  }, [microphonePermission, setMicCheck])

  const handleButtonClick = () => {
    setSpinning((prevState) => !prevState)
    setSeed(Math.random())
  }

  return (
    <>
      <div>
        <ToastContainer style={{ zIndex: 9999 }} /> {/* to show above all */}
        <DragAndMoveComponent />
        <CreateTripDialog />
        <MovePositionDialog />
        {/* ✅ Desktop view (don’t touch) */}
        {!isMobile && (
          <>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  width: '100%'
                }}
              >
                <div className="sidebar-main">
                  <Sidebar />
                </div>
                <div
                  className="mapsContainer"
                  style={{ flex: '1', top: '128px' }}
                >
                  <GoogleMapContainer key={seed} />
                </div>
                <div style={{ width: '255px', height: '100vh' }}>
                  <GpsTable />
                </div>
              </div>
            </div>
            <CreateTripButton
              handleButtonClick={handleButtonClick}
              isSpinning={isSpinning}
            />
          </>
        )}
        {/* ✅ Mobile view */}
        {isMobile && (
          <>
            <div style={{ position: 'relative', zIndex: 1 }}>
              <ToastContainer style={{ zIndex: 9999 }} />
              {/* to show above all */}
              <DragAndMoveComponent />
              <CreateTripDialog />
              <MovePositionDialog />
              <div
                className="mapsContainer"
                style={{ flex: 1, height: '100vh' }}
              >
                <GoogleMapContainer key={seed} />
              </div>
              {/* <BottomSheet
              className="bottom_sheet"
              open={true}
              blocking={false}
              snapPoints={({ minHeight, maxHeight }) => [
                minHeight / 2.85,
                maxHeight / 3,
                maxHeight * 0.45
              ]}
              defaultSnap={({ lastSnap, snapPoints }) =>
                lastSnap ?? Math.min(...snapPoints)
              }
            > */}
              {/* Floating GPS Button */}
              <button
                onClick={() => setIsDrawerOpen(true)}
                style={{
                  position: 'fixed',
                  bottom: '10px',
                  right: '10px',
                  backgroundColor: 'red',
                  color: 'white',
                  padding: '10px',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  zIndex: 9999,
                  transition: 'opacity 0.3s ease-in-out'
                }}
              >
                <img
                  src="\images\gps_location_map_navigation_pin_icon .svg"
                  alt="Open"
                  width="40"
                  height="40"
                />
              </button>
              {/* Drawer Content */}
              {isDrawerOpen && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    right: 0,
                    // width: '70vw',
                    height: '100vh',
                    backgroundColor: 'white',
                    boxShadow: '-2px 0px 10px rgba(0,0,0,0.2)',
                    padding: '10px',
                    transition: 'right 0.5s ease-in-out',
                    zIndex: 10000,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start'
                  }}
                >
                  {/* Close Drawer Button */}
                  <button
                    onClick={() => setIsDrawerOpen(false)}
                    style={{
                      position: 'fixed',
                      bottom: '10px',
                      right: 'clamp(150px, 65vw, 265px)',
                      backgroundColor: 'red',
                      color: 'white',
                      padding: '10px',
                      border: 'none',
                      borderRadius: '50%',
                      zIndex: 10001,
                      cursor: 'pointer'
                    }}
                  >
                    <img
                      src="\images\cancel_close_delete_icon .svg"
                      alt="close"
                      width="40"
                      height="40"
                    />
                  </button>
                  <GpsTable />
                </div>
              )}
              <div className="sidebar-main">
                <Sidebar />
              </div>
              <CreateTripButton
                handleButtonClick={handleButtonClick}
                isSpinning={isSpinning}
              />
            </div>
            {/* </BottomSheet> */}
          </>
        )}
      </div>
    </>
  )
}
export default GPS
